module.exports = "../../../../platform/assets/pageMainIcon/danjuweihulei8.svg";